export const ONE_SECOND = 1000;
export const ONE_MINUTE = 60 * ONE_SECOND;
export const ONE_HOUR = 60 * ONE_MINUTE;
export const ONE_DAY = ONE_HOUR * 24;
export const ONE_WEEK = ONE_DAY * 7;
export const ONE_AVERAGE_MONTH = ONE_DAY * 30;
export const ONE_AVERAGE_YEAR = ONE_DAY * 365;

export const TIME_DELIMITER = ':';
export const TIME_AM = 'AM';
export const TIME_PM = 'PM';
